// extracted by mini-css-extract-plugin
export var noSpinners = "_ms-6";
export var percentageInput = "_ms-7";
export var variantColor1 = "_ms-0";
export var variantColor2 = "_ms-1";
export var variantColor3 = "_ms-2";
export var variantColor4 = "_ms-3";
export var variantColor5 = "_ms-4";
export var variantColor6 = "_ms-5";